import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";

const previewUrl = (token) =>
  resolveApiUrl(`/api/subscription/setup/${encodeURIComponent(token)}`);
const billingSessionUrl = (token) =>
  resolveApiUrl(`/api/subscription/setup/${encodeURIComponent(token)}/billing-session`);
const completeUrl = (token) =>
  resolveApiUrl(`/api/subscription/setup/${encodeURIComponent(token)}/complete`);

export const SUBSCRIPTION_SETUP_TOKEN_KEY = "hr_subscription_setup_token";

export async function getSubscriptionSetupPreview(token) {
  const { data } = await axios.get(previewUrl(token), {
    withCredentials: true,
    validateStatus: () => true,
  });
  return data;
}

export async function postSubscriptionSetupBillingSession(token) {
  const { data } = await axios.post(
    billingSessionUrl(token),
    {},
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    },
  );
  return data;
}

export async function postSubscriptionSetupComplete(token, redirectParams) {
  const { data } = await axios.post(
    completeUrl(token),
    { redirectParams: redirectParams || {} },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    },
  );
  return data;
}
